<div class="invite-wrapper">
<div class="invite-container">

  <wm-common-text
    [data]="{ text: 'Invite User' }"
    class="title">
  </wm-common-text>

  <!-- 👇 NEW WRAPPER -->
 <div class="invite-content">

  <div class="user-email-wrapper">
    <wm-common-textfield
      #emailModel="ngModel"
      [data]="{
        label: 'User Email',
        placeholder: 'Enter user email',
        required: true,
        type: 'email'
      }"
      [(ngModel)]="userEmail">
    </wm-common-textfield>
  </div>

  <wm-common-text
    [data]="{ text: 'Add User to following role(s)' }"
    class="roles-title">
  </wm-common-text>
  <!-- ROLES LOADER (TEXT ONLY, TWO SIDE BY SIDE) -->
<div *ngIf="isRolesLoading" class="roles-grid">
  <div class="role-text-skeleton" *ngFor="let _ of [1,2]"></div>
</div>

  <div class="roles-grid">
    <div class="role-item" *ngFor="let r of roles">
      <label class="checkbox-row">
        <input type="checkbox" [(ngModel)]="r.selected" class="checkbox" />
        <span class="role-text">{{ r.name }}</span>
      </label>
    </div>
  </div>

</div>


  <div class="footer">
    <button class="cancel-btn" (click)="cancel()">CANCEL</button>
    <button
      class="invite-btn"
      [disabled]="isRolesLoading || !canInvite"
      (click)="submitInvite(emailModel)">
      INVITE
    </button>
  </div>

</div>
</div>
<!-- ================================================= -->
<!-- COMMON CONFIRMATION MODAL -->
<!-- ================================================= -->
<wm-common-confirmation-modal
  [data]="confirmationModalData"
  (onOkClick)="handleModalOk()"
  [isApplicantMobileview]="true">
</wm-common-confirmation-modal>

